"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SLOT_KEYS = void 0;
/**
 * Canonical list of step-slot collection keys. Every validator,
 * slot-materialiser, and step-type definition iterates these three
 * keys — duplicating the list invites drift (one callsite forgets
 * `outputSlots`, bindings become invisible to downstream consumers).
 */
exports.SLOT_KEYS = ['inputSlots', 'configSlots', 'outputSlots'];
